/* tslint:disable */
import {
  UserProfile,
  PropertyUnits,
  CompanyAccount,
  FileManager
} from '../index';

declare var Object: any;
export interface TenantUnitInterface {
  "tenant_id": number;
  "property_id": number;
  "property_unit_id": number;
  "application_status": string;
  "tenant_role": string;
  "exit_step"?: number;
  "exit_type"?: string;
  "rejection_reason"?: string;
  "application_date"?: Date;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  tenants?: UserProfile;
  propertyUnits?: PropertyUnits;
  property?: CompanyAccount;
  files?: FileManager[];
}

export class TenantUnit implements TenantUnitInterface {
  "tenant_id": number;
  "property_id": number;
  "property_unit_id": number;
  "application_status": string;
  "tenant_role": string;
  "exit_step": number;
  "exit_type": string;
  "rejection_reason": string;
  "application_date": Date;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  tenants: UserProfile;
  propertyUnits: PropertyUnits;
  property: CompanyAccount;
  files: FileManager[];
  constructor(data?: TenantUnitInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantUnit`.
   */
  public static getModelName() {
    return "TenantUnit";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantUnit for dynamic purposes.
  **/
  public static factory(data: TenantUnitInterface): TenantUnit{
    return new TenantUnit(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantUnit',
      plural: 'TenantUnits',
      path: 'TenantUnits',
      idName: 'id',
      properties: {
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "application_status": {
          name: 'application_status',
          type: 'string',
          default: 'APPROVED'
        },
        "tenant_role": {
          name: 'tenant_role',
          type: 'string',
          default: 'APPLICANT'
        },
        "exit_step": {
          name: 'exit_step',
          type: 'number',
          default: 0
        },
        "exit_type": {
          name: 'exit_type',
          type: 'string'
        },
        "rejection_reason": {
          name: 'rejection_reason',
          type: 'string'
        },
        "application_date": {
          name: 'application_date',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        tenants: {
          name: 'tenants',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        files: {
          name: 'files',
          type: 'FileManager[]',
          model: 'FileManager',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'model_item_id'
        },
      }
    }
  }
}
